module.exports = __webpack_public_path__ + "static/img/propTechDesign.ce61366e.png";